import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b08e398c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=b08e398c&prod&lang=scss&"
import style1 from "./detail.vue?vue&type=style&index=1&id=b08e398c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08e398c",
  null
  
)

export default component.exports